import { render, staticRenderFns } from "./CTablePagination.vue?vue&type=template&id=2eb1158e&"
import script from "./CTablePagination.vue?vue&type=script&lang=js&"
export * from "./CTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports